import { createRouter, createWebHashHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import KontakView from '../views/KontakView.vue';
import BeritaView from '../views/BeritaView.vue';
import PPIDView from '../views/PPIDView.vue';
import PengumumanView from '../views/PengumumanView.vue';
import PageView from "../views/PageView.vue";
import DetailView from "../views/DetailView.vue";
import DetailBeritaView from "../views/DetailBeritaView.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  {
    path: '/KontakView',
    name: 'KontakView',
    component: KontakView,
  },
  {
    path: '/Berita',
    name: 'BeritaView',
    component: BeritaView,
  },
  { path: "/Berita/:id", name: "DetailBeritaView", component: DetailBeritaView, props: true },
  { path: "/Pengumuman/:id", name: "DetailView", component: DetailView, props: true },
  {
    path: '/Pengumuman',
    name: 'PengumumanView',
    component: PengumumanView,
  },
  {
    path: '/PPID',
    name: 'PPIDView',
    component: PPIDView,
  },
  { path: "/page/:id", name: "PageView", component: PageView, props: true },
  {
    path: "/page/slug/:slug",
    name: "PageSlug",
    component: PageView,
    props: true
  }
];

const router = createRouter({
  history: createWebHashHistory('/'),
  routes,
});

export default router;
